import React, { Component } from 'react';
import DocumentsTable from './components/DocumentsTable';
import DocumentsHeader from './components/DocumentsHeader';
import AuthService from './AuthService';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

class Documents extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      userAuthenticated: this.Auth.userAuthenticated(),
      documents: [],
      user: this.Auth.getUser()
    };
    this.updateDocuments = this.updateDocuments.bind(this);
  }

  componentDidMount() {
    this.fetchDocuments();
  }

  updateDocuments() {
    this.fetchDocuments();
  }

  fetchDocuments() {
    axios(`${process.env.REACT_APP_API_URL}/documents/kiosk/inperson`, {
      method: 'GET',
      mode: 'cors'
    })
      .then(response => {
        this.setState({ documents: response.data.Items });
      })
      .catch(e => {
        console.log('error', e);
      });
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { userAuthenticated } = this.state;
    const { user } = this.state;

    if (
      userAuthenticated === false ||
      user === false ||
      localStorage.userGroup
    ) {
      return <Redirect to={from} />;
    }

    return (
      <div>
        <DocumentsHeader user={this.state.user} />
        <DocumentsTable
          documents={this.state.documents}
          updateDocuments={this.updateDocuments}
          user={this.state.user}
        />
      </div>
    );
  }
}

export default Documents;



// WEBPACK FOOTER //
// ./src/Documents.js